const Site = {
	pages: [
		{	
			title: 'Home',
			id: 'home', 
			index: 0,
			slides: [
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'Love this airport...<br/> so easy.',
						sub: 'Linda K.'
					}
				},
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'A nice clean airport with<br/> friendly people working there.<br/> Easy in and easy out!',
						sub: 'Nicole L.'
					}
				},
				{	
					template: 'borderedContent',
					content: {
						header: '<span>John Wayne Airport</span><br/> 2018 Annual Report',
						main: '<span>You ask.</span> We deliver.',
						sub: 'Committed to going the extra mile for you'
					}
				},

			]
		},
		{
			title: 'Superior Guest Experience',
			id: 'experience', 
			index: 1,
			slides: [
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'What separates a good<br/> travel experience from<br/> a great one?',
						sub: ''
					}
				},
				{	
					template: 'fullBgImage',
					content: {
						header: 'Superior Guest Experience',
						main: "<span class='block'>We’re delivering satisfaction at every turn</span> At John Wayne Airport, we take pride in paying attention to the small details and creating “stand-out” service from arrival to departure. Everything we do centers around one thing – elevating the guest experience for everyone traveling through our Airport.",
						supp: '',
						image: 'experience-1-image.jpg'
					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Top in customer<br/> satisfaction…again!',
						main: 'For the second year in a row, John Wayne Airport was ranked as the highest rated airport by <span>J.D. Power</span> for customer satisfaction among large airports in North America. Also named “Best in the U.S.” by <span>Frommers</span>, and received “2018 Best Airport in the U.S.” award from <span>Money magazine.</span>',
						supp: '',
						image: 'experience-2-image.svg'

					}
				},
				{	
					template: 'borderedTwoColumn',
					content: {
						header: 'Making sweet music',
						main: 'We launched the JWAlive music program in the Thomas F. Riley Terminal. Ticketed guests can now enjoy live acoustic guitar and piano performances, creating a relaxing and entertaining environment while waiting for a flight.',
						supp: 'experience-3-supp.png',
						image: 'experience-3-image.jpg'

					}
				},
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'I walked around the corner and<br/> was pleasantly surprised to see a<br/> musician. It put a smile on my face.',
						sub: ''
					}
				},
				{	
					template: 'bgImageTwoColumn',
					content: {
						header: 'More nonstop service',
						main: "Frontier Airlines began nonstop service to Austin and San Antonio, helping passengers reach their destination faster.",
						supp: 'experience-5-supp.png',
						image: 'experience-5-image.jpg'
					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Looking ahead',
						main: 'In 2019, watch for <span>more power outlets/USB ports</span> throughout the Terminal.<br class="break"/><br class="break"/> More options for <span>local OC flavors</span> & <span>specialty retail stores.</span><br class="break"/><br class="break"/> The ability to <span>pre-order concessions</span> from your smartphone for pickup or delivery to your gate. ',
						supp: '',
						image: 'experience-6-image.jpg'

					}
				},
			]
		},
		{
			title: 'A Good Neighbor',
			id: 'neighbor', 
			index: 2,
			slides: [
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'At John Wayne Airport we have a relentless<br/> focus on adhering to strict regulations in<br/> consideration of the local community.',
						sub: ''
					},
				},
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'A Good Neighbor',
						sub: 'Fostering goodwill in our community'
					}
				},
				{	
					template: 'borderedTwoColumn',
					content: {
						header: 'Orange County proud',
						main: '<span class="block">A valuable member of the local community</span> For John Wayne Airport, being a good neighbor means respecting noise limits, alleviating traffic congestion on roadways, maintaining timely communication, and keeping our local landscape sustainable and looking beautiful. Orange County, we’re in this together. ',
						supp: '',
						image: 'neighbor-2-image.jpg'

					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Smarter ride pickups',
						main: 'We introduced new pick-up locations for passengers using ride apps <span>Lyft</span>, <span>Uber</span> and <span>Wingz</span> to improve safety and relieve congestion on the arrival level roadway. We also created a vehicle turnout in front of Terminal C for faster, easier taxi pickups.',
						supp: '',
						image: 'neighbor-3-image.jpg'

					}
				},
				{	
					template: 'bgImageTwoColumn',
					content: {
						header: 'Powering a greener airport',
						main: "We upgraded lighting systems in Parking Structures A2 and B with higher efficiency light fixtures, and installed 100 new electric vehicle charging stations.",
						supp: 'neighbor-4-supp.png',
						image: 'neighbor-4-image.jpg'
					}
				},
				{	
					template: 'borderedTwoColumn',
					content: {
						header: 'Award-winning food <br/>waste reduction',
						main: 'We received an award from the Orange County Business Council for our food waste diversion program, which reduces the organics sent to landfills and puts it to beneficial reuse. The program includes food recovery and an innovative food waste collection program.',
						supp: 'neighbor-5-supp.png',
						image: 'neighbor-5-image.jpg'

					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'A more eco-friendly environment',
						main: 'John Wayne Airport completed landscape improvements to the Campus Drive median, including drip irrigation and the addition of drought-tolerant plants.',
						supp: 'neighbor-6-supp.png',
						image: 'neighbor-6-image.jpg'

					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Keeping communication lines open',
						main: 'We conducted three public workshops for the City of Newport Beach on the roles and responsibilities of the JWA Airport Noise Office to help educate city staff and residents.<p class="neighbor-p"><span>More accessibility and automation</span><br/> This year, new facility improvements will help us comply with the latest ADA requirements, and a state-of-the-art noise complaint system will enable a better experience for submitting comments, while automating report processing.</p>',
						supp: 'neighbor-7-supp.svg',
						image: 'neighbor-7-image.jpg'

					}
				},
				{	
					template: 'twoColumnBg',
					content: {
						columnOne: {
							header: 'neighbor-8-image.svg',
							img: true
						},
						columnTwo: {
							header: 'Blog on',
							main: 'Our new JWA Blog, <span>JWA Direct</span>, began in March as a more timely complement to the quarterly JWA newsletter. In 2018, 29 articles were published both as stand-alone posts and as part of the newsletter. It’s one more way we keep stakeholders informed.',
							supp: '',
						}
					}
				},

			]
		},
		{
			title: 'Comfort & Convenience',
			id: 'convenience', 
			index: 3,
			slides: [
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Hungry?',
						main: '',
						supp: 'convenience-0-supp.png',
						image: 'convenience-0-image.jpg'

					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Looking to relax?',
						main: '',
						supp: 'convenience-1-supp.png',
						image: 'convenience-1-image.jpg'

					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Need to pass the time?',
						main: '',
						supp: 'convenience-2-supp.png',
						image: 'convenience-2-image.jpg'

					}
				},
				{	
					template: 'bgImageTwoColumn',
					content: {
						header: 'Comfort & convenience',
						main: "<span class='block'>We’ve got you covered</span> From the finest Orange County concessions and relaxing massage treatments to productive work spaces with USB charging stations and free high-speed Wi-Fi, you can find everything you need to satisfy your cravings and stay productive at John Wayne Airport. While you're here, you can check email, enjoy a cup of tea, or simply relax before your flight.",
						supp: '',
						image: 'convenience-3-image.jpg'
					}
				},
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'It is a nice and relaxing<br/> airport to go through.',
						sub: 'Grant J.'
					}
				},
				{	
					template: 'borderedTwoColumn',
					content: {
						header: 'Personalized travel assistance',
						main: 'We launched the <span>Helping Hands</span> program to ease some of the stress associated with airport travel for individuals with hidden disabilities, such as Autism. The program helps guide travelers through the arrival, check-in, security and boarding process—lending a helping hand when needed.',
						supp: '',
						image: 'convenience-5-image.jpg'

					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Thirsty?',
						main: '<span class="block">We’ll help you stay hydrated</span> We installed water bottle refilling stations in all three Terminals—allowing water bottles of virtually any size to be refilled with fresh, cold and filtered water.',
						supp: '',
						image: 'convenience-6-image.jpg'

					}
				},
				{	
					template: 'bgImageTwoColumn',
					content: {
						header: 'Fast & easy',
						main: "John Wayne Airport introduced FlashValet, a mobile app that provides faster check-in and check-out, vehicle drop-off and pick-up via text request, and convenient payment options, including mobile payment.",
						supp: 'convenience-7-supp.png',
						image: 'convenience-7-image.jpg'
					}
				},
				{	
					template: 'twoColumnBg',
					content: {
						columnOne: {
							header: 'Helping people get to their destination is what we do best.',
							img: false
						},
						columnTwo: {
							header: '',
							main: '<span class="block">virtual “tour guide”</span> 2019 will bring interactive concession wayfinding signage that will help guests locate gates, stores, restaurants, and highlight what they offer.',
							supp: '',
						}
					}
				}
			]
		},
		{
			title: 'Safety & Security',
			id: 'security', 
			index: 4,
			slides: [
				{	
					template: 'borderedTwoColumn',
					content: {
						header: 'Safety & Security',
						main: '<span class="block">Travel with total confidence</span> Whether you’re in our Terminal, boarding a plane or just arriving, John Wayne Airport is vigilant about maintaining the highest degree of safety and security, and meets or exceeds all federally mandated security regulations. We’ve got security covered, so you can relax and travel with ease.',
						supp: 'security-0-supp.png',
						image: 'security-0-image.jpg'

					}
				},
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'Safety and security are critical<br/> to our mission at JWA, protecting lives<br/> and property on and around the airfield.',
						sub: ''
					}
				},
				{	
					template: 'fullBgImage',
					content: {
						header: 'Improvements Complete!',
						main: "We completed the Terminals A and B Improvements Project. This phased endeavor included numerous safety, code compliance, comfort, convenience, and aesthetic improvements, including seismic retrofits of our structural columns to improve earthquake preparedness.",
						supp: 'security-2-supp.png',
						image: 'security-2-image.jpg'
					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Prepared for emergencies',
						main: 'We planned and implemented three emergency exercises with several law enforcement agencies and Emergency Operations Center responders, including two active shooter response scenarios and a tabletop active shooter scenario. Also joined the City of Newport Beach on an Air/Sea Disaster Plan and Water Rescue tabletop exercise.',
						supp: 'security-3-supp.png',
						image: 'security-3-image.jpg'

					}
				},
				{	
					template: 'bgImageTwoColumn',
					content: {
						header: 'Ensuring your peace of mind',
						main: "Together with the Orange County Fire Authority <span>(OCFA)</span>, who provide firefighting and rescue services at John Wayne Airport on a 24/7 basis, JWA welcomed <span>Crash 2</span>. This new state-of-the-art Oshkosh Striker Aircraft Rescue and Fire Fighting <span>(ARFF)</span> vehicle will ensure that airfield assets and JWA guests are protected in the event of an emergency.",
						supp: '',
						image: 'security-4-image.jpg'
					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Enhanced credit card security',
						main: 'We upgraded our parking system with Near Field Communication <span>(NFC)</span> capability, as well as Europay, MasterCard and Visa <span>(EMV)</span> chip technology. This new system provides an additional level of security to credit card transactions and provides multiple payment options for JWA guests, including the ability to use ApplePay.',
						supp: '',
						image: 'security-5-image.jpg'

					}
				},
				{	
					template: 'borderedTwoColumn',
					content: {
						header: 'Future Improvements',
						main: 'Our sights are set on renovating the Communications Control Center, along with the adjacent Operations, Maintenance, and Public Affairs spaces in our Terminal administrative offices. This will enhance the overall security, safety, and emergency response functions carried out by everyone from these teams.',
						supp: '',
						image: 'security-6-image.jpg'

					}
				},
			]
		},
		{
			title: 'Financially Sound',
			id: 'sound', 
			index: 5,
			slides: [
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'Financially Sound',
						sub: "Protecting Orange County's Investment"
					},
				},
				{	
					template: 'twoColumnBg',
					content: {
						columnOne: {
							header: 'sound-1-image.svg',
							img: true
						},
						columnTwo: {
							header: 'Conservative stewardship continues',
							main: 'Our financial stability is a long-standing hallmark of John Wayne Airport’s operation. Our experienced team retains conservative financial policies and executes proactive rate adjustments. And our strong reserves and bond ratings reflect our solid and conservative stewardship.',
							supp: '<a href="https://www.ocair.com/investorrelations/financials/auditedfinancialstatements/FY17-18.pdf" target="_blank"><div class="report-btn"><span class="barlow">FINANCIAL REPORT</span></div></a>',
						}
					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'Stable cost efficiency',
						main: 'In 2018, we maintained a stable Cost Per Enplanement <span>(CPE)</span> of $10.03, consistent with the CPE ten-year average of $10.06, and continued to maintain excellent credit ratings with all three rating agencies (<span>-AA</span> and <span>A<span class="special">a</span>1</span>).',
						supp: '',
						image: 'sound-2-image.svg'

					}
				},
				{	
					template: 'borderedTwoColumn',
					content: {
						header: 'Less paper. More savings.',
						main: "Process improvements helped us eliminate the mailing of monthly activity statements to more than 500 ground transportation providers. We're now using an online file sharing service to save operating costs with paper, printing, handling and mailing. ",
						supp: '',
						image: 'sound-3-image.jpg'

					}
				},
				{	
					template: 'fullBgImage',
					content: {
						header: 'Airport transformation in progress',
						main: "We completed a comprehensive report analyzing various financial and development models for our five-year General Aviation Improvement Program (<span>GAIP</span>) that will help reimagine the south side of the Airport.",
						supp: '',
						image: 'sound-4-image.jpg'
					}
				},
				{	
					template: 'bgImageTwoColumn',
					content: {
						header: 'Preparing for the future',
						main: "In 2019 we'll upgrade power technologies to avoid spikes in energy demands, and make even more strides to fund future projects, refinance bonds and achieve new interest cost savings.",
						supp: '',
						image: 'sound-5-image.jpg'
					}
				},
				{	
					template: 'centeredTwoColumn',
					content: {
						header: 'A Solid Year of<br/> Improvements with<br/> More to Come',
						main: 'From the most critical processes to the smallest details, John Wayne Airport continues to display a commitment to excellence. We’ll never stop working to make it the very best travel experience.<br class="break"/><br class="break"/> <span>Keep flying with us, and watch for even more enhancements coming your way in 2019.</span>',
						supp: '',
						image: 'sound-6-image.jpg'

					}
				},
				{	
					template: 'borderedContent',
					content: {
						header: '',
						main: 'At John Wayne Airport, it’s all about<br/> you—meeting your needs, providing<br/> options and making your travel easy.',
						sub: 'barry Rondinella, AIRPORT DIRECTOR, JOHN WAYNE airport'
					}
				}
			]
		}
	]
};

module.exports = Site;